import React from "react";
import {Modal, Pressable, ScrollView} from "react-native";
import MainStyle from "../../MainStyle";
import Button from "../components/Button";
import {colors} from "../assets/styles/colors";
import Div from "../lib/Div";
import P from "../lib/P";
import {TournamentSurveyQuestion, TournamentSurveyQuestionType} from "../../generated/smg_service_pb";
import Input from "../components/Input";
import {FormikProps} from "formik";
import {toCapitalize} from "../utils";
import icon from "../assets/img/icons/pencil-line 1.svg";
import Select from "../components/Select";
import Checkbox from "../components/Checkbox";

type Props = {
  visible: boolean, onClose: () => void, questionsList: TournamentSurveyQuestion[],
  formik: FormikProps<Record<string, string[]>>
};

const AdditionalSurveyQuestions = (props: Props) => {
  const {visible, questionsList, formik} = props;

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <Div h="100%" w="100%" bg={colors.modalBg} style={MainStyle.fix_gradient_and_modal_error_in_landscape}>
        <ScrollView contentContainerStyle={styles.wrapScroll}>
          <Div w="100%" maxW={390} maxH={710} rounded={20} borderWidth={1} borderColor={colors.settings_border}
               bg={colors.settings_bg} pt={35}>
            <P ta="center" fw="500" fs={26} mb={33}>{`Additional\nSurvey Questions`}</P>

            <ScrollView>
              {questionsList.map(question => {
                const currentValues: string[] = formik.values[question.id] || [];

                return (
                  <Div mb={30} alignItems="center" key={question.id}>
                    <P ta="center" fw="500" mb={7}>{question.text}</P>

                    {question.type === TournamentSurveyQuestionType.TEXT_ENTRY ? (
                      <Input
                        placeholder="Your answer" value={currentValues[0] || ''}
                        onChangeText={val => formik.setFieldValue(`${question.id}`, [val])}
                        onBlur={formik.handleBlur(`${question.id}`)} error={formik.errors[question.id] as string || ''}
                        w={330} h={48} onFocusScroll mb={12} rounded={20} borderColor={colors.settings_border}
                        bg="black" fs={18} placeholderTextColor="white" px={20}
                      />
                    ) : question.type === TournamentSurveyQuestionType.DROPDOWN ? (
                      <Select
                        value={currentValues[0] || ''}
                        onChangeText={val => formik.setFieldValue(`${question.id}`, [val])}
                        customItems={question.options.map(el => ({value: el, label: el}))} w={330}
                        borderRadius={20} h={48} placeholder="Select your response" textAlign="left" icon={icon}
                        fontSize={18} pl={20} pr={21} bg="black" color="white" iconSize={24}
                        borderColor={formik.errors[question.id] ? colors.newDangerText : colors.settings_border}
                        popupTitle="Select your response" errorText={formik.errors[question.id] as string}
                      />
                    ) : (
                      <>
                        {formik.errors[question.id] && (
                          <P flex={1} ta="center" fw="500" fs={12} color={colors.newDangerText}>
                            {toCapitalize(formik.errors[question.id] as string)}
                          </P>
                        )}

                        {question.options.map(option => {
                          const isChecked = currentValues.includes(option);
                          const updatedValues = isChecked ? currentValues.filter((val) => val !== option) : [...currentValues, option];

                          return (
                            <Pressable key={option}
                                       style={[MainStyle.row, MainStyle.a_i_c, MainStyle.w_312, MainStyle.m_y_6]}
                                       onPress={() => formik.setFieldValue(`${question.id}`, updatedValues)}>
                              <Checkbox
                                value={isChecked} size={18}
                                onValueChange={() => formik.setFieldValue(`${question.id}`, updatedValues)}
                              />
                              <P fs={18} fw="500" ml={15}>{option}</P>
                            </Pressable>
                          );
                        })}
                      </>
                    )}
                  </Div>
                );
              })}
            </ScrollView>

            <Div mx={10} h={1} bg={colors.divider_bg} mb={26}/>

            <Div w={310} row justifyContent="space-between" mx="auto" mb={36}>
              <Button
                onPress={props.onClose} w={150} bg={colors.mainBackground} borderWidth={1} borderColor="white"
                color="white" text="Cancel"
              />
              <Button onPress={formik.submitForm} w={150} text="Submit"/>
            </Div>
          </Div>
        </ScrollView>
      </Div>
    </Modal>
  );
};

const styles = {
  wrapScroll: [MainStyle.full_h, MainStyle.full_w, MainStyle.p_x_20, MainStyle.a_i_c, MainStyle.j_c_c]
};

export default React.memo(AdditionalSurveyQuestions);
